import getUser from '../getters/user'
import sendNotification from './send_notification'

const constructMessageNotification = (message, user) => {
  if (!message || !user) return

  return {
    payload: message, time: message.time,
    from: message.from, to: message.to,
    title: user.get('name'), icon: user.get('profileImage'), body: message.message,
    read: false, isReceived: false
  }
}

const sendMessageNotification = (message) => {
  return getUser(message.from)
    .then(constructMessageNotification.bind(null, message))
    .then(sendNotification.bind(null, `messages/${message.to}`))
}

const getMessage = (ref) => {
  return ref.once('value')
    .then((snapshot) => {
      const message = snapshot.val()

      if (!message.from) return getMessage(snapshot.ref())

      return message
    })
}

export default (ref) => {
  return getMessage(ref)
    .then(sendMessageNotification)
    .then(() => ref)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/send_message_notification.js
 **/